import React, {
    useRef,
    useState,
    useImperativeHandle,
    useEffect,
    DetailedHTMLProps,
    HTMLAttributes,
} from 'react';
import { PrototypeCheck } from '../utils';
import { TableBase } from '..';
import { TableBaseProps } from '../table-base';
import { usePrevious } from 'react-use';

export interface FormInputSearchTableConfig extends TableBaseProps {
    ExtraHeader?: any;
    ExtraFooter?: any;
    normalizeValue?: any;
    normalizeApiParams?: Function;
    normalizeInputValue?: Function;
    onRowCB?: any;
    onRow?: any;
    searchKey?: any;
}

type IProps = { tableConfig: FormInputSearchTableConfig; onRowCB: any; inputValue: any };

const InputSearchTable = (
    props: Partial<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> & IProps,
    ref: any
) => {
    const [tableVisible, setTableVisible] = useState(false);
    const {
        fetchApi,
        ExtraHeader,
        ExtraFooter,
        normalizeValue,
        searchKey,
        onRow,
        normalizeApiParams,
        normalizeInputValue,
        ...rest
    }: any = props.tableConfig;
    const [apiParam, setApiParam] = useState<any>();
    const tableRef = useRef<any>();

    const prevParam = usePrevious(apiParam);

    

    const { onRowCB, inputValue, style } = props;

    const clickRowCb = (record: any) => {
        setTableVisible(false);
        onRowCB &&
            onRowCB(
                normalizeValue,
                record,
                normalizeInputValue ? normalizeInputValue(record) : null
            );
    };

    const handleContainerClick = (event: any) => {
        event.nativeEvent.stopImmediatePropagation(); //阻止冒泡
    };

    const setRow = (record: any) => {
        return {
            [onRow]: () => {
                clickRowCb(record);
            },
        };
    };

    useImperativeHandle(ref, () => ({
        setTableVisible,
    }));

    useEffect(() => {
        function setUnVisible() {
            setTableVisible(false);
        }
        document.addEventListener('click', setUnVisible);
        return () => document.removeEventListener('click', setUnVisible);
    }, []);

    useEffect(() => {
        tableVisible &&
            setApiParam({
                [searchKey]: inputValue,
            });
    }, [searchKey, inputValue, tableVisible]);

    return (
        <div
            className="inputsearch-table-container"
            style={{ display: tableVisible ? 'block' : 'none', ...style }}
            onClick={handleContainerClick}
        >
            <div className="inputsearch-table-header">
                {PrototypeCheck.isFunction(ExtraHeader) ? (
                    <ExtraHeader tableRef={tableRef} setTableVisible={setTableVisible} />
                ) : (
                    ''
                )}
            </div>
            <div className="inputsearch-table">
                <TableBase
                    ref={tableRef}
                    fetchApi={fetchApi}
                    apiParams={normalizeApiParams ? normalizeApiParams(apiParam) : apiParam}
                    onRow={(record: any) => setRow.call(null, record)}
                    onPageChange={(pageNo, pageSize) =>
                        setApiParam({ ...prevParam, ...apiParam, pageNo, pageSize })
                    }
                    {...rest}
                />
            </div>
            <div className="inputsearch-table-footer">
                {PrototypeCheck.isFunction(ExtraFooter) ? (
                    <ExtraFooter tableRef={tableRef} setTableVisible={setTableVisible} />
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

export default React.forwardRef(InputSearchTable);
